var _path, _path2, _path3, _circle, _g, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinth3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 959.92 868.87",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m180.9 240.6h-121.2l60.6-60.6z",
    fill: "#fb6340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.3 240.6v-240h240z",
    fill: "#2dce89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m240.3 240.6-240-240h240z",
    fill: "#f4f5f7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 782.25,
    cy: 576.09,
    fill: "#f4f5f7",
    r: 100.84
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1645.34 -1625.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2431.11 2080.66a116.5 116.5 0 0 1 116.52 116.48v3.5h-3.5a116.5 116.5 0 0 1 -116.52-116.49v-3.49z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2311.13 2200.68h-3.5v-3.5a116.5 116.5 0 0 1 116.48-116.52h3.5v3.49a116.5 116.5 0 0 1 -116.48 116.53z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2424.13 2200.66h3.5v3.49a116.51 116.51 0 0 1 -116.49 116.53h-3.49v-3.5a116.5 116.5 0 0 1 116.48-116.52z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2544.15 2320.64a116.5 116.5 0 0 1 -116.52-116.49v-3.49h3.5a116.5 116.5 0 0 1 116.52 116.48v3.5z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1765.34 1866h120v120a120 120 0 0 1 -120 120h-120v-120a120 120 0 0 1 120-120z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1765.34 1917.89a70.55 70.55 0 1 1 0 141.1h-70.55v-70.55a70.55 70.55 0 0 1 70.55-70.55z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1837.94 1866h48v48a72 72 0 0 1 -72 72h-48v-48a72 72 0 0 1 72-72z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2559.14 1868.44v72.56a72.53 72.53 0 0 1 -72.53-72.53z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2412.58 1868.44h72.53a72.53 72.53 0 0 1 -72.53 72.53z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2007.46 1866a120 120 0 1 0 0 240h120v-120a120 120 0 0 0 -120-120z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2055.7 1962.51a71.76 71.76 0 1 0 0 143.52h71.76v-71.76a71.76 71.76 0 0 0 -71.76-71.76z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2007.46 1911.56a73.27 73.27 0 1 0 73.26 73.26 73.26 73.26 0 0 0 -73.26-73.26z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2007.46 1941.93a42.89 42.89 0 1 0 42.89 42.89 42.89 42.89 0 0 0 -42.89-42.89z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2365.48 1746v119.4h-119.39a120.61 120.61 0 0 1 -120.61-120.61v-119.36h119.4a120.59 120.59 0 0 1 120.6 120.57z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2313.62 1745.43a70.55 70.55 0 1 1 -141.1 0v-70.56h70.55a70.55 70.55 0 0 1 70.55 70.56z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2365.48 1818v48h-48a72 72 0 0 1 -72-72v-48h48a72 72 0 0 1 72 72z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2291.92 2108.44a120 120 0 0 0 0-240h-120v120a120 120 0 0 0 120 120z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2243.68 2012a71.76 71.76 0 1 0 0-143.52h-71.76v71.76a71.76 71.76 0 0 0 71.76 71.76z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2291.92 2062.91a73.27 73.27 0 1 0 -73.27-73.26 73.26 73.26 0 0 0 73.27 73.26z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2291.92 2032.54a42.89 42.89 0 1 0 -42.89-42.89 42.89 42.89 0 0 0 42.89 42.89z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2451.79 2079.11a59 59 0 1 0 59-59 59 59 0 0 0 -59 59z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1730.2 2237a33.21 33.21 0 1 0 33.21-33.21 33.21 33.21 0 0 0 -33.21 33.21z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1869.61 2237a59 59 0 1 0 59-59 59 59 0 0 0 -59 59z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1955.93 2494 49.8-33.71a60.44 60.44 0 1 0 -83.73-16.29z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1991.82 2379a33.21 33.21 0 1 0 33.21-33.21 33.2 33.2 0 0 0 -33.21 33.21z",
    fill: "#fb6340"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.52,
    cy: 120,
    fill: "#f5365c",
    r: 120
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.12,
    cy: 120.6,
    fill: "#172b4d",
    r: 70.45
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.12,
    cy: 120.6,
    fill: "#2dce89",
    r: 37.01
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 839.92,
    cy: 120.9,
    fill: "#fb6340",
    r: 120
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.52,
    cy: 120.3,
    fill: "#172b4d",
    r: 70.45
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.52,
    cy: 120.3,
    fill: "#f4f5f7",
    r: 37.01
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1645.34 -1625.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2269.08 2063.56c0 66-53.33 119.41-119.12 119.41.04-65.97 53.33-119.41 119.12-119.41z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2147.46 2182.54 1.62 3.07-3.06 1.62c-56.45 29.89-126.49 8.24-156.45-48.34l-1.63-3.08 3.07-1.62c56.44-29.89 126.49-8.19 156.45 48.35z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2102 2278.41 1.5-3.13 3.14 1.5c57.74 27.68 82.16 96.8 54.55 154.4l-1.5 3.13-3.13-1.51c-57.78-27.67-82.2-96.8-54.56-154.39z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2269.08 2300.09v3.47h-3.47c-63.87 0-115.65-51.9-115.65-115.93v-3.48h3.47c63.87 0 115.65 51.91 115.65 115.94z",
    fill: "#2dce89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinth3);
export default __webpack_public_path__ + "static/media/linth3.def7f2b7a139df5da1d5296ce517f647.svg";
export { ForwardRef as ReactComponent };